let timeoutAction: any;
let timeoutEnable: any;

export const withoutTransition = (action: () => any) => {
  clearTimeout(timeoutAction);
  clearTimeout(timeoutEnable);

  const style = document.createElement('style');

  const css = document.createTextNode(`* {
     -webkit-transition: none !important;
     -moz-transition: none !important;
     -o-transition: none !important;
     -ms-transition: none !important;
     transition: none !important;
  }`);
  style.appendChild(css);

  const disable = () => document.head.appendChild(style);
  const enable = () => document.head.removeChild(style);

  if (typeof window.getComputedStyle !== 'undefined') {
    disable();
    action();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    window.getComputedStyle(style).opacity;
    setTimeout(() => {
      enable();
    }, 800);
    return;
  }
};
